<template lang="pug">
div.search-results(v-if="results")
	template(v-if="totalNumberOfHits >= 1")
		.search-results__header
			VueSelect.search-results__order(
					id="search-results-order"
					v-model="order"
				)
					VueSelectOption(v-for="(item, index) in orderValues", :value="item.key", :text="item.value", :index="index", label-id="label1" :key="item.key")
			span.total 
				strong {{ totalNumberOfHits }} 
				| {{ $t('ALIST.hitsText') }}
		div(ref="resultsTop", tabindex="0")
		ul.search-result__card-list
			li.search-result__listitem(v-for="searchResult in results")
				ResultCard(:result="searchResult")
		.search-results__pagination
			VuePagination(v-model="currentPage", :page-size="8", :total-rows="totalNumberOfHits", :firstLastPage="true", :has-max-page="false", @input="changePage")
		.search-results__save(v-if="!searchModel.model.isOwnedByFactoring")
			.m17-property-list__save-search(v-if="isLoggedIn && !tooManySavedSearches && !alreadyExistingSearchName")
				p {{$t('ALIST.savedSearchesNews')}}
				button.btn-primary.btn-primary--green(@click="openSaveSearchForm") {{$t('ALIST.saveSearch')}}
			.m17-property-list__save-search(v-if="tooManySavedSearches")
				p {{$t('ALIST.tooManySavedSearches')}}
				a.btn-primary.btn-primary--green(:href="savedSearchesUrl") {{$t('ALIST.savedSearches')}}
			.m17-property-list__save-search(v-if="isLoggedIn && !tooManySavedSearches && alreadyExistingSearchName")
				p {{$t('ALIST.existingSavedSearch')}} "{{alreadyExistingSearchName}}"
				a.btn-primary.btn-primary--green(:href="savedSearchesUrl") {{$t('ALIST.savedSearches')}}
			.m17-property-list__save-search(v-if="!isLoggedIn")
				p {{$t('ALIST.savedSearchesNews')}}
				button.btn-primary.btn-primary--green(@click="openLoginForm") {{$t('ALIST.saveSearch')}}




	.section__container.section__container--smaller(v-if="totalNumberOfHits == 0")
		.search-results__no-results
			h5 Sajnáljuk!
			p A megadott keresési feltételeknek megfelelően nincs ingatlan!
			p Módosítson szűrési feltételein, és indítson új keresést.
			p Viszont ha csak pénz hiányzik, tudunk segíteni. Egészítse ki önrészét hitellel, és vegye meg álmai ingatlanát!
</template>
<script>
import * as R from 'ramda';
import ResultCard from '../../common/components/result-card/result-card';
import VuePagination from '@ui-common/vue-pagination';
import lang from '../../common/js/lang/lang';
import { VueSelect, VueSelectOption } from '@ui-common/vue-select';
import { ORDER_TYPES } from '../../common/js/constants/constants';
import { mapGetters, mapState } from 'vuex';
import restUrlService from '../../common/js/url/rest-url-service';
import savedSearchApi from '../../api/saved-search-api';
const translateALIST = (key) => lang.t(`ALIST.${key}`);
const MAX_SAVED_SEARCH_COUNT = 30;
const mapOptionsALIST = R.map(R.applySpec({ key: R.identity, value: translateALIST }));
export default {
	data: () => ({
		currentPage: 1,
		order: ORDER_TYPES[2],
		alreadyExistingSearchName: null,
		searchCount: 0
	}),
	components: {
		ResultCard,
		VuePagination,
		VueSelect,
		VueSelectOption
	},
	props: {
		savedSearchesUrl: {
			type: String,
			required: false,
			default: '/mentett-keresesek'
		}
	},
	watch: {
		order(val) {
			window.ipEventBus.publish('change-order', val);
		},
		async searchResults(val) {
			this.getSavedSearchInfo();
			await this.$nextTick();
			this.$refs.resultsTop && this.$refs.resultsTop.focus();
		}
	},
	computed: {
		...mapState('auth', ['isLoggedIn']),
		...mapState('search', ['searchResults', 'searchModel']),
		...mapGetters('auth', ['isLoggedIn']),
		results() {
			return this.searchResults?.hits?.content;
		},
		totalNumberOfHits() {
			return this.searchResults?.hits?.totalElements;
		},
		orderValues: () => mapOptionsALIST(ORDER_TYPES),
		tooManySavedSearches() {
			return this.searchCount >= MAX_SAVED_SEARCH_COUNT;
		}
	},
	methods: {
		changePage(page) {
			window.ipEventBus.publish('change-page', page);
		},
		openSaveSearchForm(e) {
			const mergedModel = R.mergeAll([this.searchModel.model, this.searchModel.advanced]);
			const params = restUrlService.createUrlFromState(mergedModel);
			const paramsWithoutPaging = R.omit(['page', 'pageSize'], params);
			window.ipEventBus.publish('open-save-search-form', paramsWithoutPaging);
		},
		openLoginForm(e) {
			window.ipEventBus.publish('open-login-form', e);
		},
		async checkSavedSearchExist() {
			try {
				const response = await savedSearchApi.exists(window.location.href);
				this.alreadyExistingSearchName = response.data.name;
			} catch (err) {
				if (err.response.status != 404 && err.response.status != 401) {
					window.ipEventBus.publish('show-error', {
						message: 'technicalError'
					});
				} else {
					this.alreadyExistingSearchName = null;
				}
			}
		},
		async getSavedSearchCount() {
			try {
				const response = await savedSearchApi.getNumberOfSavedSearches();
				this.searchCount = response.data.count;
			} catch (err) {
				if (err.response.status != 404 && err.response.status != 401) {
					window.ipEventBus.publish('show-error', {
						message: 'technicalError'
					});
				}
			}
		},
		async getSavedSearchInfo() {
			if (this.isLoggedIn) {
				this.checkSavedSearchExist();
				this.getSavedSearchCount();
			}
		}
	},
	created() {
		window.ipEventBus.subscribe('change-order-url', (channel, order) => {
			if (this.order != order) {
				this.order = order;
			}
		});
		window.ipEventBus.subscribe('change-page', (channel, page) => {
			if (this.currentPage != page) {
				this.currentPage = page;
			}
		});

		window.ipEventBus.subscribe('search-saved', (channel, alreadyExistingSearchName) => {
			this.alreadyExistingSearchName = alreadyExistingSearchName;
		});
	}
};
</script>
<style src="@ui-common/vue-pagination/dist/vue-pagination.css"></style>
<style lang="css" scoped>
@import '../../common/variables.pcss';
.search-results {
	padding: 0 16px;

	@media (--desktop) {
		padding: 80px  40px 0;
	}
}

.search-results__header {
	display: flex;
	flex-direction: column;
	margin: 0 -16px;
	padding: 8px 0;
	text-align: center;

	@media (--desktop) {
		align-items: center;
		flex-direction: row;
		justify-content: space-between;
		padding: 16px 0;
	}
}

.sf-select.search-results__order {
	width: auto;
	@media (--mobile-only) {
		order: 2;
	}
}

.sf-select.search-results__order >>> button,
.sf-select-wrapper.search-results__order >>> select {
	border: 0;
	color: var(--green);
	font-size: 14px;
	font-weight: 700;
}

.sf-select.search-results__order >>> .sf-select__button-wrapper::before,
.sf-select-wrapper.search-results__order::before {
	border-bottom: 2px solid var(--green);
	border-left: 2px solid var(--green);
}

.sf-select.search-results__order >>> .sf-select__button-wrapper::before {
	right: 0;
	top: 16px;
}
.sf-select.sf-select--open.search-results__order >>> .sf-select__button-wrapper::before {
	top: calc(50% + 2px);
}
.sf-select.search-results__order >>> .sf-select__options-wrapper {
	width: auto;
	max-width: unset;
	top: 44px;
}

.sf-select.search-results__order >>> .sf-select__options-wrapper ul {
	margin-top: 0;
}

.sf-select.search-results__order >>> .sf-select__options li {
	white-space: nowrap;
	text-align: left;
}

.sf-select.search-results__order >>> .sf-select__button-text {
	max-width: unset;
	padding-right: 6px;
}

.total {
	color: var(--black);
	opacity: 0.5;
	@media (--mobile-only) {
		order: 1;
	}
}

.search-result__card-list {
	display: flex;
	flex-direction: column;
	margin-bottom: 20px;

	@media (--desktop) {
		flex-direction: row;
		flex-wrap: wrap;
		margin-right: -16px;
		min-height: 468px;
	}
}

.search-result__listitem {
	@media (--desktop) {
		margin-right: 16px;
		width: calc(25% - 16px);
	}
}

.search-results__no-results {
	@media (--desktop) {
		display: flex;
		flex-direction: column;
		height: 238px;
		justify-content: center;
	}
}

.search-results__pagination {
	border-top: 1px solid var(--grey-c5);
	margin-bottom: 20px;
	padding-top: 20px;

	@media (--desktop) {
		margin-left: -16px;
		margin-right: -16px;
	}
}

.search-results__pagination >>> .sf-pagination {
	border-bottom: 1px solid var(--grey-c5);
	padding-bottom: 20px;
}

.search-results__save button,
.search-results__save a {
	border: 0;
	margin: 0;
	font-size: 20px;
	font-weight: 600;
	margin-bottom: 32px;

	@media (--desktop) {
		width: 288px;
	}
}

.search-results >>> .sf-pagination__item.active button {
	background-color: transparent;
}
</style>
